module.exports = __webpack_public_path__ + "static/about-img-86772e58b3ac837543b1c528091e8743.jpg";